module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/white-house/white-house@3x.svg"